<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto" height="180">
      <v-card-text class="text-h6 font-weight-black"> Matrículas Iniciais </v-card-text>

      <v-row>
        <v-col cols="12">
          <v-card-text class="text-h4 font-weight-black">
            {{ qtd ?? 0 }}
          </v-card-text>
          <v-card-text class="text-caption grey--text mt-n4">
            Matrículas criadas até o dia 05/02/{{ anoAtual }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MatriculasIniciaisCard",
  mounted() {
    this.getQtd();
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    anoAtual() {
      return this.user.ano.descricao;
    },
  },
  data() {
    return {
      qtd: 0,
      loading: true,
    };
  },
  methods: {
    async getQtd() {
      const response = await this.$services.matriculasService.qtdIniciais();
      this.qtd = response.qtd;
      this.loading = false;
    },
  },
};
</script>
